import { useEffect, useState } from "react";
import { getDashboardSetting, updateDashboardSetting } from "../../../api/DashboardApi";
import { toast } from "react-toastify";
import DataViewPage from "../../controls/DataViewPage";
import CustomTable from "../../controls/CustomTable";
import AddDashboardSetting from "./AddDashboardSetting";
import ConfirmBox from "../../controls/ConfirmBox";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/slices/userSlice";

const DashboardSetting = () => {
    const user=useSelector(selectUser);
    const [showConfirmation,setShowConfirmation]=useState(false);
    const [selectedWidget, setSelectedWidget] = useState({});
    const [selectedWidgetIndex, setSelectedWidgetIndex] = useState(-1);
    const [widgetOptionAmtOrQty, setWidgetOptionAmtOrQty] = useState("amount");
    const [widgetOptionTopX, setWidgetOptionTopX] = useState(5);
    const [widgetOptionProductType, setWidgetOptionProductType] = useState("goods for sale");

    const [widgetOptionPaymentMode, setWidgetOptionPaymentMode] = useState("");
    const [widgetOptionPaymentModeID, setWidgetOptionPaymentModeID] = useState("");

    const [widgetOptionTransactionTypeIDs, setWidgetOptionTransactionTypeIDs] = useState([]);
    const [widgetOptionIncludeBalance, setWidgetOptionIncludeBalance] = useState(false);
    const [widgetOptionIncludeTransactionTypes, setWidgetOptionIncludeTransactionTypes] = useState(false);

    const [widgetOptionLeftBlockColor, setWidgetOptionLeftBlockColor] = useState("");
    const [widgetOptionLeftBlockIcon, setWidgetOptionLeftBlockIcon] = useState("");

    const [dashboardSetting, setDashboardSetting] = useState([]);
    const [selectedWidgetTitle, setSelectedWidgetTitle] = useState("");
    const [showWidgetRemoveOption, setShowWidgetRemoveOption] = useState(false);

    const [titleError, setTitleError] = useState("");
    const [colorError, setColorError] = useState("");
    const [iconError, setIconError] = useState("");
    const [paymentModeError, setPaymentModeError] = useState("");
    const [loading,setLoading]=useState(false);

    const [showAddDashboardSetting,setShowAddDashboardSetting]=useState(false);

    const fetchDashboardSettingData=async()=>{
        try{
            setLoading(true);
        const response=await getDashboardSetting();
         console.log("response",response);
         if(response.code=="0"){
setDashboardSetting(response.dashboardSetting);
         }
         else{
            toast.error(response?.message || "Failed to load dashboard setting");
            setDashboardSetting([]);
         }
         
        }
        catch(error){
        toast.error(error?.message || "failed to load dashboard setting")
        }
        finally{
            setLoading(false);
        }
    }
     useEffect(()=>{
    fetchDashboardSettingData();
     },[])

 

     const columns=[
     {headerName:"Title",field:"Title"},
      {headerName:"Widget",field:"Name"},
     ]

     const onRefresh=()=>{
        fetchDashboardSettingData();
     }

     const onRemoveWidget=async()=>{
        setLoading(true);
setShowConfirmation(false);
const allWidgets = dashboardSetting?.Widgets || [];

const filteredWidgets = allWidgets.filter((widget, index) => {
  // keep widget if it does NOT match both conditions
  return !(
    widget.Widget === selectedWidget?.Widget &&
    index === selectedWidgetIndex
  );
});

// store this
const selectedWdigets = filteredWidgets;

        try{
              let dashboardSettings = {
            UID:user.UID,
            RegistrationID: user.RegistrationID,
            Widgets: selectedWdigets
        }
const response=await updateDashboardSetting(dashboardSetting?.key,dashboardSettings);
if(response.code=="0"){
toast.success("setting updated successfully");
handleCancelDelete();
onRefresh();
}
else{
    toast.error(response?.message ||"failed to remove");
}
        }
        catch(error){
           toast.error(error?.message ||"failed to remove");
        }
        finally{
            setLoading(false);
        }
     }
    const handleCancelDelete=()=>{
        setSelectedWidget({});
        setSelectedWidgetIndex(-1);
        setShowConfirmation(false);
    } 
    return (
        <div>
             <DataViewPage
          iconType={"setup"}
          title="Dashboard Setting"
          hideFooter={true}
            handleOnRefresh={onRefresh}
          header={{
           
            createButton: {
              createButton: true,
              createButtonText: "New",
              onCreateClick: () => {
    setShowAddDashboardSetting(true);
  }
            },
          }}
         
        >
        

          <CustomTable
            columns={columns}
            loading={loading}
            rows={dashboardSetting?.Widgets}
            showTextOnRows={
              dashboardSetting?.Widgets?.length > 0
                ? null
                  : "No setting found"
            }
            handleDelete={(widget,index)=>{setShowConfirmation(true),setSelectedWidget(widget),setSelectedWidgetIndex(index),console.log("index",index)}}

          />
        </DataViewPage>
   {showConfirmation &&
        <ConfirmBox
          title={
            <>
              Are you sure you want to delete{" "}
              <span className="text-red-500">{selectedWidget?.Title}</span>?
            </>
          }
          text="This action cannot be undone."
          onConfirm={onRemoveWidget}
          onCancel={handleCancelDelete}
        />
      

   }
        {showAddDashboardSetting &&
        
        <AddDashboardSetting
        closeDrawer={setShowAddDashboardSetting}
        onSave={()=>{setShowAddDashboardSetting(false)}}
        onCancel={()=>{setShowAddDashboardSetting(false)}}
        />
        }

        </div>
    )
}
export default DashboardSetting;